import React from "react"
import Layout from "../components/Layouts"
import Intro from "../components/Intro/Intro"
import Works from "../components/works/Works"
import Blogs from "../components/Blogs/Blogs"
import ContactLink from "../components/Contact-link/ContactLink"

export default function Home() {
  return (
      <Layout>
        <Intro/>
        <Works/>
        <Blogs/>
        <ContactLink/>
      </Layout>
      )
}
